import request from '@/lib/request/'

const baseUri = 'tag_art'

/**
 * @returns {Promise}
 */
export function get () {
  return request({
    url: baseUri,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/tag_art/index.js